import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

/**
 * Implemented by components that hold unsaved user input. The guard calls
 * `canDeactivate()` on navigation; returning an Observable lets the component
 * ask for confirmation (e.g. via a dialog) before the route changes.
 */
export interface ConfirmableDeactivate {
  canDeactivate(): boolean | Observable<boolean>;
}

export const unsavedChangesGuard: CanDeactivateFn<ConfirmableDeactivate> = (component) =>
  component.canDeactivate ? component.canDeactivate() : true;
